
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../vue-loader/lib/style-rewriter?id=data-v-69ad6dfa!../../../vue-loader/lib/selector?type=styles&index=0!./index.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-69ad6dfa!../../../vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue2-datatable-component/src/Table/index.vue
// module id = 1219
// module chunks = 2